import { Dispatch, SetStateAction } from 'react';
import { useMutation, useQueryClient } from 'react-query';

import { errorMessage } from '@features/applications';
import axiosInstance from '@server/axiosInstance';
import { approveSpamAccountRoute, blockSpamAccountRoute, deleteAdminEmployerRoute } from '../api/constant';
import { adminEmployersList, adminEnterprisesList, blockAccountList, spamAccountList } from '../constants';

type useBlockSpamEmployerProps = {
    setAlertText?: Dispatch<SetStateAction<string>>;
};

export const useBlockSpamEmployer = ({
    setAlertText = () => { },
}: useBlockSpamEmployerProps) => {
    const client = useQueryClient();

    const { mutate: blockSpamEmployer, isLoading: isBlockSpamEmployerLoading } =
        useMutation({
            mutationFn: (variables: {
                company_id: number | string;
            }) =>
                axiosInstance
                    .post(blockSpamAccountRoute, variables, {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                        },
                    })
                    .then((res) => res.data),
            onSuccess: (data) => {
                if (data.status !== 200) {
                    setAlertText(data.message);
                } else if (data.status === 200) {
                    client.invalidateQueries(adminEmployersList);
                    client.invalidateQueries(adminEnterprisesList);
                    client.invalidateQueries(spamAccountList);
                    client.invalidateQueries(blockAccountList);
                    setAlertText('');
                }
            },
            onError: () => {
                setAlertText(errorMessage);
            },
        });
    return {
        blockSpamEmployer,
        isBlockSpamEmployerLoading,
    };
};
